module.exports = __webpack_public_path__ + "img/icon-templates.ea3e2325.svg";